import React from 'react';
import * as Ons from 'react-onsenui';
import Toolbar from '../Toolbar';
import { translate as _ } from '../../util/i18n';
import { POSITION_CENTER, POSITION_GOALKEEPER, POSITION_LEFT_DEFENDER, POSITION_LEFT_FORWARD, POSITION_RIGHT_DEFENDER, POSITION_RIGHT_FORWARD } from '../../store/constants/misc';
import PlayerList from '../../containers/PlayerList';
import { deepCopy } from '../../util';
import Modal from '../Modal';
import NumericInput from '@hockeydata/numeric-input';

class LineupEditor extends React.Component {

    #modes

    constructor( props ) {

        // console.log( 'components.Pages.LineupEditor.constructor()', props );

        super( props );

        this.state = {
            jerseyNrEditorPlayer: null,
            mode:                 0,
            roster:               this.props.roster ? deepCopy( this.props.roster ) : [],
            selectedLine:         null,
            selectedPosition:     null
        };

        this.handleClearPositionClick    = this.handleClearPositionClick.bind( this );
        this.handleDeselectPositionClick = this.handleDeselectPositionClick.bind( this );
        this.handleJerseyNrEditorCancel  = this.handleJerseyNrEditorCancel.bind( this );
        this.handleJerseyNrEditorClose   = this.handleJerseyNrEditorClose.bind( this );
        this.handleModeSelect            = this.handleModeSelect.bind( this );
        this.handlePlayerClick           = this.handlePlayerClick.bind( this );
        this.handlePositionClick         = this.handlePositionClick.bind( this );
        this.handleSubmit                = this.handleSubmit.bind( this );

        this.#modes     = [ _( 'Setzen' ), <>{ _( 'Start' ) } <Ons.Icon icon="fa-star" /></>, 'C', 'A', '-', '#' ];

    }

    componentDidUpdate() {

        if ( this.props.roster && this.props.roster.length !== this.state.roster.length ) {

            this.setState( { roster: this.props.roster } )

        }

    }

    getPlayer( line, position ) {

        const player = this.state.roster.find( e => e.lineupData.line === line && e.lineupData.position === position );

        return player ? deepCopy( player ) : null;

    }

    handleClearPositionClick() {

        if ( this.state.mode === 0 && this.state.selectedLine && this.state.selectedPosition ) {

            const player = this.getPlayer( this.state.selectedLine, this.state.selectedPosition );

            if ( ! player ) {

                return;

            }

            player.lineupData.line = null;

            this.updatePlayers( [ player ], () => this.setState( { selectedLine: null, selectedPosition: null } ) );

        }

    }

    handleDeselectPositionClick() {

        this.setState( { selectedLine: null, selectedPosition: null } )

    }

    handleJerseyNrEditorClose( e ) {

        const player = deepCopy( this.state.jerseyNrEditorPlayer );

        player.lineupData.jerseyNr = Number( e );

        this.updatePlayers( [ player ], () => this.setState( { jerseyNrEditorPlayer: null } ) );

    }

    handleJerseyNrEditorCancel() {

        this.setState( { jerseyNrEditorPlayer: null } );

    }

    handleModeSelect( e ) {

        // e.index is always -1 on Android! Onsen bug?
        // this.setState( { mode: Number( e.index ) } );
        this.setState( { mode: Number( e.target.querySelector( 'input:checked' ).value ) } );

    }

    handlePlayerClick( player ) {

        if ( this.state.mode === 0 && this.state.selectedLine && this.state.selectedPosition ) {

            const players = [];
            let oldPlayer = this.state.roster.find( e => e.lineupData.line === this.state.selectedLine && e.lineupData.position === this.state.selectedPosition );

            if ( oldPlayer ) {

                oldPlayer                     = deepCopy( oldPlayer );
                oldPlayer.lineupData.line     = null;
                oldPlayer.lineupData.captain  = null;
                oldPlayer.lineupData.starting = null;

                players.push( oldPlayer );

            }

            player.lineupData.line     = this.state.selectedLine;
            player.lineupData.position = this.state.selectedPosition;

            players.push( player );
            this.updatePlayers( players, () => this.setState( { selectedLine: null, selectedPosition: null } ) );

        }

    }

    handlePositionClick( line, position ) {

        switch( this.state.mode ) {

            case 1:  return this.toggleStartingPlayer( line, position );
            case 2:  return this.setCaptain(           line, position );
            case 3:  return this.setAssistantCaptain(  line, position );
            case 4:  return this.unsetCaptain(         line, position );
            case 5:  return this.setJerseyNr(          line, position );
            default: return this.selectPosition(       line, position );

        }

    }

    handleSubmit() {

        this.props.onSubmit( this.state.roster )

    }

    selectPosition( selectedLine, selectedPosition ) {

        this.setState( { selectedLine, selectedPosition } )

    }

    setAssistantCaptain( line, position ) {

        const player = this.getPlayer( line, position );

        if ( ! player || player.lineupData.position === POSITION_GOALKEEPER ) {

            return;

        }

        const assistantCaptains = this.state.roster.filter( e => e.lineupData.captain === 'A' );

        if ( assistantCaptains.length < 2 ) {

            player.lineupData.captain = 'A';

            this.updatePlayers( [ player ] );

        }

    }

    setCaptain( line, position ) {

        const player = this.getPlayer( line, position );

        if ( ! player || player.lineupData.position === POSITION_GOALKEEPER ) {

            return;

        }

        const players  = [];
        let oldCaptain = this.state.roster.find( e => e.lineupData.captain === 'C' );

        if ( oldCaptain ) {

            oldCaptain                    = deepCopy( oldCaptain );
            oldCaptain.lineupData.captain = null;

            players.push( oldCaptain );

        }

        player.lineupData.captain = 'C';

        players.push( player );
        this.updatePlayers( players );

    }

    setJerseyNr( line, position ) {

        const jerseyNrEditorPlayer = this.getPlayer( line, position );

        if ( ! jerseyNrEditorPlayer ) {

            return;

        }

        this.setState( { jerseyNrEditorPlayer } )

    }

    toggleStartingPlayer( line, position ) {

        const player = this.getPlayer( line, position );

        if ( ! player ) {

            return;

        }

        if ( player.lineupData.starting ) {

            player.lineupData.starting = null;

        } else {

            const startingPlayers = this.state.roster.filter( e => e.lineupData.starting );

            if ( startingPlayers.length < 6 ) {

                player.lineupData.starting = true;

            }

        }

        this.updatePlayers( [ player ] );

    }

    unsetCaptain( line, position ) {

        const player = this.getPlayer( line, position );

        if ( ! player ) {

            return;

        }

        player.lineupData.captain = null;

        this.updatePlayers( [ player ] );

    }

    updatePlayers( players, callback ) {

        const roster = deepCopy( this.state.roster );

        players.forEach( player => {

            const playerIndex     = roster.findIndex( e => e.id === player.id );
            roster[ playerIndex ] = player;

        } );

        this.setState( { roster }, callback );

    }

    renderPosition( line, position ) {

        const player = this.state.roster.find( e => e.lineupData.line === line && e.lineupData.position === position )

        return (

            <div className={'position' + ( this.state.mode === 0 && this.state.selectedLine === line && this.state.selectedPosition === position ? ' selected' : '' )} onClick={() => this.handlePositionClick( line, position )}>

                { player ?

                    <div className='player'>

                        {player.lastname} {player.firstname} {player.middlename} #{player.lineupData.jerseyNr}

                        {player.lineupData.captain && <div className='captain'>{player.lineupData.captain}</div>}

                        {player.lineupData.starting && <div className='starting'><Ons.Icon icon="fa-star" /></div>}

                    </div>

                :

                    <div className="placeholder">{position}</div>

                }

            </div>

        );

    }

    render() {

        // console.log( 'components.Pages.LineupEditor.render()', this.props, this.state );

        const duplicateJerseyNrs       = [];
        const jerseyNrChecked          = {};
        const playerOnSelectedPosition = this.state.selectedLine && this.state.selectedPosition && this.state.roster.find( e => e.lineupData.line === this.state.selectedLine && e.lineupData.position === this.state.selectedPosition )
        const availablePlayers         = this.state.roster.filter( e => ! e.lineupData.line || ! e.lineupData.position )

        this.state.roster.forEach( e => {

            if ( e.lineupData.jerseyNr in jerseyNrChecked ) {

                duplicateJerseyNrs.push( e.lineupData.jerseyNr );

            } else {

                jerseyNrChecked[ e.lineupData.jerseyNr ] = true;

            }

        } );

        return (

            <Ons.Page renderToolbar={() => <Toolbar onBackClick={this.props.onCancel} right={<Ons.ToolbarButton onClick={this.handleSubmit}><Ons.Icon icon="fa-check" /> {_( 'Speichern' )}</Ons.ToolbarButton>} />}>

                <div className="padded-page-content">

                    <h1 className="page-title">{_( 'Linien bearbeiten' )}</h1>

                    <Ons.Row className="lineup-editor">

                        <Ons.Col className="positions">

                            { duplicateJerseyNrs.length > 0 && <Ons.Card className="primary"><Ons.Icon icon="fa-exclamation-triangle" /> {_( 'Achtung! Folgende Trikotnummern wurden mehrmals vergeben:' )} {duplicateJerseyNrs.map( ( e, i ) => <span key={i}>{e}{( i + 1 ) < duplicateJerseyNrs.length && ', '}</span> )}</Ons.Card> }

                            <Ons.Segment index={this.state.mode} onPostChange={this.handleModeSelect}>

                                {this.#modes.map( e => <Ons.Button key={e}>{e}</Ons.Button> )}

                            </Ons.Segment>

                            {this.state.selectedLine && this.state.selectedPosition &&

                                <Ons.Card className="selected-position">

                                    <h3>{_( 'Position besetzen' )}</h3>

                                    <Ons.Row>

                                        <Ons.Col width='100px'>{_( 'Linie' )}</Ons.Col>
                                        <Ons.Col><strong>{this.state.selectedLine}</strong></Ons.Col>

                                    </Ons.Row>

                                    <Ons.Row>

                                        <Ons.Col width='100px'>{_( 'Position' )}</Ons.Col>
                                        <Ons.Col><strong>{this.state.selectedPosition}</strong></Ons.Col>

                                    </Ons.Row>

                                    <Ons.Row>

                                        <Ons.Col width='100px'>{_( 'Aktuell' )}</Ons.Col>
                                        <Ons.Col><strong>{playerOnSelectedPosition ? <>{playerOnSelectedPosition.lastname} {playerOnSelectedPosition.firstname} {playerOnSelectedPosition.middlename} #{playerOnSelectedPosition.lineupData.jerseyNr}</> : _( 'nicht gesetzt' )}</strong></Ons.Col>

                                    </Ons.Row>

                                    <p>

                                        <Ons.Button onClick={this.handleDeselectPositionClick}>{_( 'Abbrechen' )}</Ons.Button>

                                    </p>

                                </Ons.Card>

                            }

                            <div className={'lineup-editor-lines' + ( this.state.selectedLine && this.state.selectedPosition ? ' position-selected' : '' )}>

                                { Array.from( { length: 4 } ).map( ( e, i ) =>

                                    <div key={i} className="lineup-editor-line">

                                        <h3>{_( 'Linie' )} {i + 1}</h3>

                                        <div className="position-group">

                                            {this.renderPosition(i + 1, POSITION_LEFT_FORWARD)}
                                            {this.renderPosition(i + 1, POSITION_CENTER)}
                                            {this.renderPosition(i + 1, POSITION_RIGHT_FORWARD)}

                                        </div>

                                        <div className="position-group">

                                            {this.renderPosition(i + 1, POSITION_LEFT_DEFENDER)}
                                            {this.renderPosition(i + 1, POSITION_RIGHT_DEFENDER)}

                                        </div>

                                        <div className="position-group">

                                            {this.renderPosition(i + 1, POSITION_GOALKEEPER)}

                                        </div>

                                    </div>

                                ) }

                            </div>

                        </Ons.Col>

                        <Ons.Col className="players">

                            <h3>{_( 'Verfügbare Spieler' )} ({availablePlayers.length})</h3>

                            <PlayerList
                                onPlayerActivate={() => false}
                                onPlayerClick={this.handlePlayerClick}
                                playerIsActive={() => false}
                                players={availablePlayers}
                                playersActivatable={() => false}
                                type="Players"
                            />

                            <p><Ons.Button modifier='large' onClick={this.handleClearPositionClick}>{_( 'Position nicht besetzen' )}</Ons.Button></p>

                        </Ons.Col>

                    </Ons.Row>

                </div>

                {this.state.jerseyNrEditorPlayer !== null && <Modal><NumericInput onClose={this.handleJerseyNrEditorClose} onCancel={this.handleJerseyNrEditorCancel} value={this.state.jerseyNrEditorPlayer.lineupData.jerseyNr}></NumericInput></Modal>}

                { this.props.loading && <Modal><div className="loading"><Ons.Icon icon='fa-spinner' spin={true}></Ons.Icon></div></Modal>}

            </Ons.Page>

        );

    }

}

export default LineupEditor;